"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAllPublicMarketDetails = exports.getMarketHrefLang = exports.getMarketDetails = exports.LTR_MARKETS = exports.RTL_MARKETS = exports.MARKETS_WITH_INTERNAL = exports.PUBLIC_MARKETS = exports.getDefaultMarketId = exports.getMarketIds = exports.marketLookupMap = exports.MARKET_SUBPATHS = exports.MARKET_SUBDOMAINS = exports.MARKET_DETAILS = exports.MARKETS = void 0;
var gasket_private_labels_1 = require("@godaddy/gasket-private-labels");
var defaultEnv = 'prod';
exports.MARKETS = [
    'ar-AE',
    'da-DK',
    'de-AT',
    'de-CH',
    'de-DE',
    'en-AE',
    'en-AU',
    'en-CA',
    'en-GB',
    'en-HK',
    'en-IE',
    'en-IL',
    'en-IN',
    'en-MY',
    'en-NZ',
    'en-PH',
    'en-PK',
    'en-SG',
    'en-US',
    'en-ZA',
    'es-AR',
    'es-CL',
    'es-CO',
    'es-ES',
    'es-MX',
    'es-PE',
    'es-US',
    'es-VE',
    'fr-BE',
    'fr-CA',
    'fr-CH',
    'fr-FR',
    'hi-IN',
    'id-ID',
    'it-CH',
    'it-IT',
    'ja-JP',
    'ko-KR',
    'nb-NO',
    'nl-BE',
    'nl-NL',
    'pl-PL',
    'pt-BR',
    'pt-PT',
    'qa-PS',
    'qa-PZ',
    'qa-QA',
    'ru-RU',
    'sv-SE',
    'th-TH',
    'tr-TR',
    'uk-UA',
    'vi-VN',
    'zh-HK',
    'zh-SG',
    'zh-TW'
];
exports.MARKET_DETAILS = [
    {
        marketId: 'ar-AE',
        internal: false,
        description: 'الإمارات العربية المتحدة - اللغة العربية',
        descriptionEnglish: 'United Arab Emirates - Arabic',
        priceGroupId: 45,
        currencies: ['AED', 'EUR', 'EGP'],
        displayTaxesAndFees: 'NONE',
        taxCountryCode: '',
        htmlDirection: 'rtl',
        isExplicitConsentMarket: false,
        hrefLang: 'ar',
        subdomain: 'ae',
        subpath: 'ar'
    },
    {
        marketId: 'da-DK',
        internal: false,
        description: 'Danmark - Dansk',
        descriptionEnglish: 'Denmark - Danish',
        priceGroupId: 11,
        currencies: ['DKK', 'EUR', 'USD'],
        displayTaxesAndFees: 'NONE',
        taxCountryCode: 'DK',
        htmlDirection: 'ltr',
        isExplicitConsentMarket: true,
        hrefLang: 'da-DK',
        subdomain: 'dk',
        subpath: null
    },
    {
        marketId: 'de-AT',
        internal: false,
        description: 'Österreich - Deutsch',
        descriptionEnglish: 'Austria - German',
        priceGroupId: 2,
        currencies: ['EUR', 'USD'],
        displayTaxesAndFees: 'ALL',
        taxCountryCode: 'AT',
        htmlDirection: 'ltr',
        isExplicitConsentMarket: true,
        hrefLang: 'de-AT',
        subdomain: null,
        subpath: 'de'
    },
    {
        marketId: 'de-CH',
        internal: false,
        description: 'Schweiz - Deutsch',
        descriptionEnglish: 'Switzerland - German',
        priceGroupId: 7,
        currencies: ['CHF', 'EUR', 'USD'],
        displayTaxesAndFees: 'ALL',
        taxCountryCode: 'CH',
        htmlDirection: 'ltr',
        isExplicitConsentMarket: true,
        hrefLang: 'de-CH',
        subdomain: null,
        subpath: 'de'
    },
    {
        marketId: 'de-DE',
        internal: false,
        description: 'Deutschland - Deutsch',
        descriptionEnglish: 'Germany - German',
        priceGroupId: 10,
        currencies: ['EUR', 'USD'],
        displayTaxesAndFees: 'ALL',
        taxCountryCode: 'DE',
        htmlDirection: 'ltr',
        isExplicitConsentMarket: true,
        hrefLang: 'de-DE',
        subdomain: null,
        subpath: 'de'
    },
    {
        marketId: 'en-AE',
        internal: false,
        description: 'United Arab Emirates - English',
        descriptionEnglish: 'United Arab Emirates - English',
        priceGroupId: 45,
        currencies: ['AED', 'EUR', 'EGP'],
        displayTaxesAndFees: 'NONE',
        taxCountryCode: '',
        htmlDirection: 'ltr',
        isExplicitConsentMarket: false,
        hrefLang: 'en-AE',
        subdomain: 'ae',
        subpath: null
    },
    {
        marketId: 'en-AU',
        internal: false,
        description: 'Australia - English',
        descriptionEnglish: 'Australia - English',
        priceGroupId: 3,
        currencies: ['AUD', 'USD'],
        displayTaxesAndFees: 'ALL',
        taxCountryCode: 'AU',
        htmlDirection: 'ltr',
        isExplicitConsentMarket: false,
        hrefLang: 'en-AU',
        subdomain: null,
        subpath: 'en-au'
    },
    {
        marketId: 'en-CA',
        internal: false,
        description: 'Canada - English',
        descriptionEnglish: 'Canada - English',
        priceGroupId: 6,
        currencies: ['CAD', 'USD'],
        displayTaxesAndFees: 'NONE',
        taxCountryCode: '',
        htmlDirection: 'ltr',
        isExplicitConsentMarket: false,
        hrefLang: 'en-CA',
        subdomain: null,
        subpath: 'en-ca'
    },
    {
        marketId: 'en-GB',
        internal: false,
        description: 'United Kingdom - English',
        descriptionEnglish: 'United Kingdom - English',
        priceGroupId: 34,
        currencies: ['GBP', 'USD'],
        displayTaxesAndFees: 'ICANN',
        taxCountryCode: '',
        htmlDirection: 'ltr',
        isExplicitConsentMarket: true,
        hrefLang: 'en-GB',
        subdomain: null,
        subpath: 'en-uk'
    },
    {
        marketId: 'en-HK',
        internal: false,
        description: 'Hong Kong - English',
        descriptionEnglish: 'Hong Kong - English',
        priceGroupId: 37,
        currencies: ['HKD', 'USD'],
        displayTaxesAndFees: 'NONE',
        taxCountryCode: '',
        htmlDirection: 'ltr',
        isExplicitConsentMarket: false,
        hrefLang: 'en-HK',
        subdomain: null,
        subpath: 'en-ie'
    },
    {
        marketId: 'en-IE',
        internal: false,
        description: 'Ireland - English',
        descriptionEnglish: 'Ireland - English',
        priceGroupId: 16,
        currencies: ['EUR', 'GBP', 'USD'],
        displayTaxesAndFees: 'NONE',
        taxCountryCode: 'IE',
        htmlDirection: 'ltr',
        isExplicitConsentMarket: true,
        hrefLang: 'en-IE',
        subdomain: null,
        subpath: 'en-ie'
    },
    {
        marketId: 'en-IL',
        internal: false,
        description: 'Israel - English',
        descriptionEnglish: 'Israel - English',
        priceGroupId: 46,
        currencies: ['ILS', 'EUR'],
        displayTaxesAndFees: 'NONE',
        taxCountryCode: 'IL',
        htmlDirection: 'ltr',
        isExplicitConsentMarket: false,
        hrefLang: 'en-IL',
        subdomain: null,
        subpath: 'en-il'
    },
    {
        marketId: 'en-IN',
        internal: false,
        description: 'India - English',
        descriptionEnglish: 'India - English',
        priceGroupId: 17,
        currencies: ['INR', 'USD'],
        displayTaxesAndFees: 'NONE',
        taxCountryCode: '',
        htmlDirection: 'ltr',
        isExplicitConsentMarket: false,
        hrefLang: 'en-IN',
        subdomain: null,
        subpath: 'en-in'
    },
    {
        marketId: 'en-MY',
        internal: false,
        description: 'Malaysia - English',
        descriptionEnglish: 'Malaysia - English',
        priceGroupId: 20,
        currencies: ['MYR', 'USD'],
        displayTaxesAndFees: 'ICANN',
        taxCountryCode: 'MY',
        htmlDirection: 'ltr',
        isExplicitConsentMarket: false,
        hrefLang: 'en-MY',
        subdomain: null,
        subpath: 'en-ph'
    },
    {
        marketId: 'en-NZ',
        internal: false,
        description: 'New Zealand - English',
        descriptionEnglish: 'New Zealand - English',
        priceGroupId: 23,
        currencies: ['NZD', 'AUD', 'USD'],
        displayTaxesAndFees: 'NONE',
        taxCountryCode: '',
        htmlDirection: 'ltr',
        isExplicitConsentMarket: false,
        hrefLang: 'en-NZ',
        subdomain: null,
        subpath: 'en-ie'
    },
    {
        marketId: 'en-PH',
        internal: false,
        description: 'Philippines - English',
        descriptionEnglish: 'Philippines - English',
        priceGroupId: 25,
        currencies: ['PHP', 'USD'],
        displayTaxesAndFees: 'ALL',
        taxCountryCode: 'PH',
        htmlDirection: 'ltr',
        isExplicitConsentMarket: false,
        hrefLang: 'en-PH',
        subdomain: null,
        subpath: 'en-ph'
    },
    {
        marketId: 'en-PK',
        internal: false,
        description: 'Pakistan - English',
        descriptionEnglish: 'Pakistan - English',
        priceGroupId: 26,
        currencies: ['PKR', 'USD', 'GBP'],
        displayTaxesAndFees: 'NONE',
        taxCountryCode: '',
        htmlDirection: 'ltr',
        isExplicitConsentMarket: false,
        hrefLang: 'en-PK',
        subdomain: null,
        subpath: 'en-ph'
    },
    {
        marketId: 'en-SG',
        internal: false,
        description: 'Singapore - English',
        descriptionEnglish: 'Singapore - English',
        priceGroupId: 31,
        currencies: ['SGD', 'USD'],
        displayTaxesAndFees: 'ICANN',
        taxCountryCode: 'SG',
        htmlDirection: 'ltr',
        isExplicitConsentMarket: false,
        hrefLang: 'en-SG',
        subdomain: null,
        subpath: 'en-sg'
    },
    {
        marketId: 'en-US',
        internal: false,
        description: 'United States - English',
        descriptionEnglish: 'United States - English',
        priceGroupId: 0,
        currencies: ['USD'],
        displayTaxesAndFees: 'NONE',
        taxCountryCode: '',
        htmlDirection: 'ltr',
        isExplicitConsentMarket: false,
        hrefLang: 'en-US',
        subdomain: null,
        subpath: null
    },
    {
        marketId: 'en-ZA',
        internal: false,
        description: 'South Africa - English',
        descriptionEnglish: 'South Africa - English',
        priceGroupId: 36,
        currencies: ['ZAR', 'USD'],
        displayTaxesAndFees: 'NONE',
        taxCountryCode: '',
        htmlDirection: 'ltr',
        isExplicitConsentMarket: false,
        hrefLang: 'en-ZA',
        subdomain: null,
        subpath: 'en-ph'
    },
    {
        marketId: 'es-AR',
        internal: false,
        description: 'Argentina - Español',
        descriptionEnglish: 'Argentina - Spanish',
        priceGroupId: 1,
        currencies: ['USD'],
        displayTaxesAndFees: 'NONE',
        taxCountryCode: '',
        htmlDirection: 'ltr',
        isExplicitConsentMarket: false,
        hrefLang: 'es-AR',
        subdomain: null,
        subpath: 'es'
    },
    {
        marketId: 'es-CL',
        internal: false,
        description: 'Chile - Español',
        descriptionEnglish: 'Chile - Spanish',
        priceGroupId: 8,
        currencies: ['CLP', 'USD'],
        displayTaxesAndFees: 'NONE',
        taxCountryCode: '',
        htmlDirection: 'ltr',
        isExplicitConsentMarket: false,
        hrefLang: 'es-CL',
        subdomain: null,
        subpath: 'es'
    },
    {
        marketId: 'es-CO',
        internal: false,
        description: 'Colombia - Español',
        descriptionEnglish: 'Colombia - Spanish',
        priceGroupId: 9,
        currencies: ['COP', 'USD'],
        displayTaxesAndFees: 'NONE',
        taxCountryCode: '',
        htmlDirection: 'ltr',
        isExplicitConsentMarket: false,
        hrefLang: 'es-CO',
        subdomain: null,
        subpath: 'es'
    },
    {
        marketId: 'es-ES',
        internal: false,
        description: 'España - Español',
        descriptionEnglish: 'Spain - Spanish',
        priceGroupId: 12,
        currencies: ['EUR', 'USD'],
        displayTaxesAndFees: 'NONE',
        taxCountryCode: 'ES',
        htmlDirection: 'ltr',
        isExplicitConsentMarket: true,
        hrefLang: 'es-ES',
        subdomain: null,
        subpath: 'es-es'
    },
    {
        marketId: 'es-MX',
        internal: false,
        description: 'México - Español',
        descriptionEnglish: 'Mexico - Spanish',
        priceGroupId: 19,
        currencies: ['MXN', 'USD'],
        displayTaxesAndFees: 'NONE',
        taxCountryCode: '',
        htmlDirection: 'ltr',
        isExplicitConsentMarket: false,
        hrefLang: 'es-MX',
        subdomain: null,
        subpath: 'es'
    },
    {
        marketId: 'es-PE',
        internal: false,
        description: 'Perú - Español',
        descriptionEnglish: 'Peru - Spanish',
        priceGroupId: 24,
        currencies: ['PEN', 'USD'],
        displayTaxesAndFees: 'NONE',
        taxCountryCode: '',
        htmlDirection: 'ltr',
        isExplicitConsentMarket: false,
        hrefLang: 'es-PE',
        subdomain: null,
        subpath: 'es'
    },
    {
        marketId: 'es-US',
        internal: false,
        description: 'Estados Unidos - Español',
        descriptionEnglish: 'United States - Spanish',
        priceGroupId: 0,
        currencies: ['USD'],
        displayTaxesAndFees: 'NONE',
        taxCountryCode: '',
        htmlDirection: 'ltr',
        isExplicitConsentMarket: false,
        hrefLang: 'es-US',
        subdomain: null,
        subpath: 'es'
    },
    {
        marketId: 'es-VE',
        internal: false,
        description: 'Venezuela - Español',
        descriptionEnglish: 'Venezuela - Spanish',
        priceGroupId: 35,
        currencies: ['USD'],
        displayTaxesAndFees: 'NONE',
        taxCountryCode: '',
        htmlDirection: 'ltr',
        isExplicitConsentMarket: false,
        hrefLang: 'es-VE',
        subdomain: null,
        subpath: 'es'
    },
    {
        marketId: 'fr-BE',
        internal: false,
        description: 'Belgique - Français',
        descriptionEnglish: 'Belgium - French',
        priceGroupId: 4,
        currencies: ['EUR', 'USD'],
        displayTaxesAndFees: 'NONE',
        taxCountryCode: 'BE',
        htmlDirection: 'ltr',
        isExplicitConsentMarket: true,
        hrefLang: 'fr-BE',
        subdomain: null,
        subpath: 'fr'
    },
    {
        marketId: 'fr-CA',
        internal: false,
        description: 'Canada - Français',
        descriptionEnglish: 'Canada - French',
        priceGroupId: 6,
        currencies: ['CAD', 'USD'],
        displayTaxesAndFees: 'NONE',
        taxCountryCode: '',
        htmlDirection: 'ltr',
        isExplicitConsentMarket: false,
        hrefLang: 'fr-CA',
        subdomain: null,
        subpath: 'fr-ca'
    },
    {
        marketId: 'fr-CH',
        internal: false,
        description: 'Suisse - Français',
        descriptionEnglish: 'Switzerland - French',
        priceGroupId: 7,
        currencies: ['CHF', 'EUR', 'USD'],
        displayTaxesAndFees: 'ALL',
        taxCountryCode: 'CH',
        htmlDirection: 'ltr',
        isExplicitConsentMarket: true,
        hrefLang: 'fr-CH',
        subdomain: null,
        subpath: 'fr'
    },
    {
        marketId: 'fr-FR',
        internal: false,
        description: 'France - Français',
        descriptionEnglish: 'France - French',
        priceGroupId: 14,
        currencies: ['EUR', 'USD'],
        displayTaxesAndFees: 'ALL',
        taxCountryCode: 'FR',
        htmlDirection: 'ltr',
        isExplicitConsentMarket: true,
        hrefLang: 'fr-FR',
        subdomain: null,
        subpath: 'fr'
    },
    {
        marketId: 'hi-IN',
        internal: false,
        description: 'India - हिंदी',
        descriptionEnglish: 'India - Hindi',
        priceGroupId: 17,
        currencies: ['INR', 'USD'],
        displayTaxesAndFees: 'NONE',
        taxCountryCode: '',
        htmlDirection: 'ltr',
        isExplicitConsentMarket: false,
        hrefLang: 'hi-IN',
        subdomain: null,
        subpath: 'hi-in'
    },
    {
        marketId: 'id-ID',
        internal: false,
        description: 'Indonesia - Bahasa Indonesia',
        descriptionEnglish: 'Indonesia - Indonesian',
        priceGroupId: 38,
        currencies: ['IDR', 'USD'],
        displayTaxesAndFees: 'ALL',
        taxCountryCode: 'ID',
        htmlDirection: 'ltr',
        isExplicitConsentMarket: false,
        hrefLang: 'id-ID',
        subdomain: null,
        subpath: 'id-id'
    },
    {
        marketId: 'it-CH',
        internal: false,
        description: 'Svizzera - Italiano',
        descriptionEnglish: 'Switzerland - Italian',
        priceGroupId: 7,
        currencies: ['CHF', 'EUR', 'USD'],
        displayTaxesAndFees: 'ALL',
        taxCountryCode: 'CH',
        htmlDirection: 'ltr',
        isExplicitConsentMarket: true,
        hrefLang: 'it-CH',
        subdomain: null,
        subpath: 'it'
    },
    {
        marketId: 'it-IT',
        internal: false,
        description: 'Italia - Italiano',
        descriptionEnglish: 'Italy - Italian',
        priceGroupId: 18,
        currencies: ['EUR', 'USD'],
        displayTaxesAndFees: 'ALL',
        taxCountryCode: 'IT',
        htmlDirection: 'ltr',
        isExplicitConsentMarket: true,
        hrefLang: 'it-IT',
        subdomain: null,
        subpath: 'it'
    },
    {
        marketId: 'ja-JP',
        internal: false,
        description: '日本 - 日本語',
        descriptionEnglish: 'Japan - Japanese',
        priceGroupId: 39,
        currencies: ['JPY', 'USD'],
        displayTaxesAndFees: 'ALL',
        taxCountryCode: 'JP',
        htmlDirection: 'ltr',
        isExplicitConsentMarket: false,
        hrefLang: 'ja-JP',
        subdomain: 'jp',
        subpath: null
    },
    {
        marketId: 'ko-KR',
        internal: false,
        description: '대한민국 - 한국어',
        descriptionEnglish: 'Korea - Korean',
        priceGroupId: 40,
        currencies: ['KRW', 'USD'],
        displayTaxesAndFees: 'ALL',
        taxCountryCode: 'KR',
        htmlDirection: 'ltr',
        isExplicitConsentMarket: false,
        hrefLang: 'ko-KR',
        subdomain: 'kr',
        subpath: null
    },
    {
        marketId: 'nb-NO',
        internal: false,
        description: 'Norge - Bokmål',
        descriptionEnglish: 'Norway - Norwegian',
        priceGroupId: 22,
        currencies: ['EUR', 'USD'],
        displayTaxesAndFees: 'NONE',
        taxCountryCode: 'NO',
        htmlDirection: 'ltr',
        isExplicitConsentMarket: true,
        hrefLang: 'nb-NO',
        subdomain: 'no',
        subpath: null
    },
    {
        marketId: 'nl-BE',
        internal: false,
        description: 'België - Nederlands',
        descriptionEnglish: 'Belgium - Dutch',
        priceGroupId: 4,
        currencies: ['EUR', 'USD'],
        displayTaxesAndFees: 'NONE',
        taxCountryCode: 'BE',
        htmlDirection: 'ltr',
        isExplicitConsentMarket: true,
        hrefLang: 'nl-BE',
        subdomain: null,
        subpath: 'nl'
    },
    {
        marketId: 'nl-NL',
        internal: false,
        description: 'Nederland - Nederlands',
        descriptionEnglish: 'Netherlands - Dutch',
        priceGroupId: 21,
        currencies: ['EUR', 'USD'],
        displayTaxesAndFees: 'NONE',
        taxCountryCode: 'NL',
        htmlDirection: 'ltr',
        isExplicitConsentMarket: true,
        hrefLang: 'nl-NL',
        subdomain: null,
        subpath: 'nl'
    },
    {
        marketId: 'pl-PL',
        internal: false,
        description: 'Polska - Polski',
        descriptionEnglish: 'Poland - Polish',
        priceGroupId: 27,
        currencies: ['PLN', 'EUR', 'GBP', 'USD'],
        displayTaxesAndFees: 'ALL',
        taxCountryCode: 'PL',
        htmlDirection: 'ltr',
        isExplicitConsentMarket: true,
        hrefLang: 'pl-PL',
        subdomain: null,
        subpath: 'pl-pl'
    },
    {
        marketId: 'pt-BR',
        internal: false,
        description: 'Brasil - Português',
        descriptionEnglish: 'Brazil - Portuguese',
        priceGroupId: 5,
        currencies: ['BRL', 'USD'],
        displayTaxesAndFees: 'NONE',
        taxCountryCode: '',
        htmlDirection: 'ltr',
        isExplicitConsentMarket: false,
        hrefLang: 'pt-BR',
        subdomain: null,
        subpath: 'pt-br'
    },
    {
        marketId: 'pt-PT',
        internal: false,
        description: 'Portugal - Português',
        descriptionEnglish: 'Portugal - Portuguese',
        priceGroupId: 28,
        currencies: ['EUR', 'GBP', 'USD'],
        displayTaxesAndFees: 'NONE',
        taxCountryCode: 'PT',
        htmlDirection: 'ltr',
        isExplicitConsentMarket: true,
        hrefLang: 'pt-PT',
        subdomain: null,
        subpath: 'pt-pt'
    },
    {
        marketId: 'qa-PS',
        internal: true,
        description: 'QA - Pseudo',
        descriptionEnglish: 'QA - Pseudo',
        priceGroupId: 0,
        currencies: ['AED'],
        displayTaxesAndFees: 'NONE',
        taxCountryCode: '',
        htmlDirection: 'ltr',
        isExplicitConsentMarket: false,
        hrefLang: '',
        subdomain: null,
        subpath: null
    },
    {
        marketId: 'qa-PZ',
        internal: true,
        description: 'QA - Zs',
        descriptionEnglish: 'QA - Zs',
        priceGroupId: 0,
        currencies: ['PKR'],
        displayTaxesAndFees: 'NONE',
        taxCountryCode: '',
        htmlDirection: 'ltr',
        isExplicitConsentMarket: false,
        hrefLang: '',
        subdomain: null,
        subpath: null
    },
    {
        marketId: 'qa-QA',
        internal: true,
        description: 'QA - Show Tags',
        descriptionEnglish: 'QA - Show Tags',
        priceGroupId: 0,
        currencies: ['AED'],
        displayTaxesAndFees: 'NONE',
        taxCountryCode: '',
        htmlDirection: 'ltr',
        isExplicitConsentMarket: false,
        hrefLang: '',
        subdomain: null,
        subpath: null
    },
    {
        marketId: 'sv-SE',
        internal: false,
        description: 'Sverige - Svenska',
        descriptionEnglish: 'Sweden - Swedish',
        priceGroupId: 30,
        currencies: ['SEK', 'EUR', 'USD'],
        displayTaxesAndFees: 'NONE',
        taxCountryCode: 'SE',
        htmlDirection: 'ltr',
        isExplicitConsentMarket: true,
        hrefLang: 'sv-SE',
        subdomain: 'se',
        subpath: null
    },
    {
        marketId: 'th-TH',
        internal: false,
        description: 'ไทย - ไทย',
        descriptionEnglish: 'Thailand - Thai',
        priceGroupId: 41,
        currencies: ['THB', 'USD'],
        displayTaxesAndFees: 'ALL',
        taxCountryCode: 'TH',
        htmlDirection: 'ltr',
        isExplicitConsentMarket: false,
        hrefLang: 'th-TH',
        subdomain: null,
        subpath: 'th-th'
    },
    {
        marketId: 'tr-TR',
        internal: false,
        description: 'Türkiye - Türkçe',
        descriptionEnglish: 'Turkey - Turkish',
        priceGroupId: 32,
        currencies: ['USD', 'EUR', 'TRY'],
        displayTaxesAndFees: 'NONE',
        taxCountryCode: '',
        htmlDirection: 'ltr',
        isExplicitConsentMarket: false,
        hrefLang: 'tr-TR',
        subdomain: null,
        subpath: 'tr-tr'
    },
    {
        marketId: 'uk-UA',
        internal: false,
        description: 'Україна - Українська',
        descriptionEnglish: 'Ukraine - Ukrainian',
        priceGroupId: 33,
        currencies: ['UAH', 'EUR', 'USD'],
        displayTaxesAndFees: 'NONE',
        taxCountryCode: '',
        htmlDirection: 'ltr',
        isExplicitConsentMarket: false,
        hrefLang: 'uk-UA',
        subdomain: null,
        subpath: 'uk-ua'
    },
    {
        marketId: 'vi-VN',
        internal: false,
        description: 'Việt Nam - Tiếng Việt',
        descriptionEnglish: 'Vietnam - Vietnamese',
        priceGroupId: 43,
        currencies: ['VND', 'USD'],
        displayTaxesAndFees: 'ALL',
        taxCountryCode: 'VN',
        htmlDirection: 'ltr',
        isExplicitConsentMarket: false,
        hrefLang: 'vi-VN',
        subdomain: null,
        subpath: 'vi-vn'
    },
    {
        marketId: 'zh-HK',
        internal: false,
        description: '香港 - 繁體中文',
        descriptionEnglish: 'Hong Kong - Traditional Chinese',
        priceGroupId: 37,
        currencies: ['HKD', 'USD'],
        displayTaxesAndFees: 'NONE',
        taxCountryCode: '',
        htmlDirection: 'ltr',
        isExplicitConsentMarket: false,
        hrefLang: 'zh-HK',
        subdomain: 'hk',
        subpath: null
    },
    {
        marketId: 'zh-SG',
        internal: false,
        description: '新加坡 - 简体中文',
        descriptionEnglish: 'Singapore - Simplified Chinese',
        priceGroupId: 31,
        currencies: ['SGD', 'CNY', 'USD'],
        displayTaxesAndFees: 'ICANN',
        taxCountryCode: 'SG',
        htmlDirection: 'ltr',
        isExplicitConsentMarket: false,
        hrefLang: 'zh-SG',
        subdomain: null,
        subpath: 'zh-sg'
    },
    {
        marketId: 'zh-TW',
        internal: false,
        description: '台灣 - 繁體中文',
        descriptionEnglish: 'Taiwan - Traditional Chinese',
        priceGroupId: 42,
        currencies: ['TWD', 'USD'],
        displayTaxesAndFees: 'ALL',
        taxCountryCode: 'TW',
        htmlDirection: 'ltr',
        isExplicitConsentMarket: false,
        hrefLang: 'zh-TW',
        subdomain: 'tw',
        subpath: null
    }
];
exports.MARKET_SUBDOMAINS = [
    'ae',
    'dk',
    'fi',
    'hk',
    'jp',
    'kr',
    'no',
    'se',
    'tw'
];
exports.MARKET_SUBPATHS = [
    'ar',
    'de',
    'en',
    'en-au',
    'en-ca',
    'en-ie',
    'en-il',
    'en-in',
    'en-my',
    'en-nz',
    'en-ph',
    'en-pk',
    'en-sg',
    'en-uk',
    'en-za',
    'es',
    'es-es',
    'fr',
    'fr-ca',
    'hi-in',
    'id-id',
    'it',
    'nl',
    'pl-pl',
    'pt-br',
    'pt-pt',
    'th-th',
    'tr-tr',
    'uk-ua',
    'vi-vn',
    'zh-sg'
];
/**
 * Market lookup map for more performant value lookups
 */
exports.marketLookupMap = exports.MARKET_DETAILS.reduce(function (acc, market) {
    acc[market.marketId] = market;
    return acc;
}, {});
/**
 * Get Market IDs with a filter
 * @param {Function} [filter] - A function to filter the market objects
 * @returns {Market[]} - An array of Market IDs
 * @example getMarketIds(({ internal }) => internal === false);
 * @example getMarketIds(({ htmlDirection }) => htmlDirection === 'rtl');
 */
function getMarketIds(filter) {
    if (filter === void 0) { filter = function () { return true; }; }
    return exports.MARKET_DETAILS.filter(filter).map(function (_a) {
        var marketId = _a.marketId;
        return marketId;
    });
}
exports.getMarketIds = getMarketIds;
function getDefaultMarketId(plid, env) {
    if (env === void 0) { env = defaultEnv; }
    var plids = (0, gasket_private_labels_1.getEnvPlids)(env);
    if (plid === plids['123reg'])
        return 'en-GB';
    return 'en-US';
}
exports.getDefaultMarketId = getDefaultMarketId;
exports.PUBLIC_MARKETS = getMarketIds(function (_a) {
    var internal = _a.internal;
    return internal === false;
});
exports.MARKETS_WITH_INTERNAL = getMarketIds(function () { return true; });
exports.RTL_MARKETS = getMarketIds(function (_a) {
    var htmlDirection = _a.htmlDirection, internal = _a.internal;
    return htmlDirection === 'rtl' && internal === false;
});
exports.LTR_MARKETS = getMarketIds(function (_a) {
    var htmlDirection = _a.htmlDirection, internal = _a.internal;
    return htmlDirection === 'ltr' && internal === false;
});
function getMarketDetails(marketId) {
    return exports.marketLookupMap[marketId] || null;
}
exports.getMarketDetails = getMarketDetails;
function getMarketHrefLang(marketId) {
    var _a;
    return ((_a = getMarketDetails(marketId)) === null || _a === void 0 ? void 0 : _a.hrefLang) || '';
}
exports.getMarketHrefLang = getMarketHrefLang;
function getAllPublicMarketDetails(plid, env) {
    if (env === void 0) { env = defaultEnv; }
    var plids = (0, gasket_private_labels_1.getEnvPlids)(env);
    // 123reg is a special case where we only want to show en-GB
    if (plid === plids['123reg'])
        return [exports.marketLookupMap['en-GB']];
    return exports.MARKET_DETAILS.filter(function (_a) {
        var internal = _a.internal;
        return !internal;
    });
}
exports.getAllPublicMarketDetails = getAllPublicMarketDetails;
